// Bookmark Form Component

import api from '../api.js';
import { loadBookmarks, getCategories, getTags } from './BookmarkList.js';

let currentBookmark = null;

export function renderBookmarkForm(bookmark = null) {
  currentBookmark = bookmark;
  const categories = getCategories();
  const tags = getTags();

  const categoryOptions = categories.map(cat =>
    `<option value="${cat.id}" ${bookmark?.category_id === cat.id ? 'selected' : ''}>${escapeHtml(cat.name)}</option>`
  ).join('');

  const tagCheckboxes = tags.map(tag => `
    <label class="tag-checkbox">
      <input type="checkbox" name="tags" value="${tag.id}" ${bookmark?.tags?.some(t => t.id === tag.id) ? 'checked' : ''}>
      ${escapeHtml(tag.name)}
    </label>
  `).join('');

  return `
    <div class="modal" id="bookmark-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>${bookmark ? 'Lesezeichen bearbeiten' : 'Neues Lesezeichen'}</h2>
          <button class="modal-close" id="close-bookmark-modal">&times;</button>
        </div>

        <form id="bookmark-form" class="form">
          <div class="form-group">
            <label for="bookmark-url">URL *</label>
            <input
              type="url"
              id="bookmark-url"
              name="url"
              required
              placeholder="https://example.com"
              value="${bookmark?.url || ''}"
            >
          </div>

          <div class="form-group">
            <label for="bookmark-title">Titel</label>
            <input
              type="text"
              id="bookmark-title"
              name="title"
              placeholder="Wird automatisch extrahiert, falls leer"
              value="${bookmark?.title || ''}"
            >
          </div>

          <div class="form-group">
            <label for="bookmark-description">Beschreibung</label>
            <textarea
              id="bookmark-description"
              name="description"
              rows="3"
              placeholder="Optional"
            >${bookmark?.description || ''}</textarea>
          </div>

          <div class="form-group">
            <label for="bookmark-category">Kategorie</label>
            <select id="bookmark-category" name="category_id">
              <option value="">Keine Kategorie</option>
              ${categoryOptions}
            </select>
          </div>

          <div class="form-group">
            <label>Tags</label>
            <div class="tag-checkboxes">
              ${tagCheckboxes || '<p class="text-muted">Keine Tags verfügbar. <a href="#" id="create-tag-link">Tag erstellen</a></p>'}
            </div>
          </div>

          <div class="form-actions">
            <button type="button" class="btn btn-secondary" id="cancel-bookmark">Abbrechen</button>
            <button type="submit" class="btn btn-primary">${bookmark ? 'Speichern' : 'Erstellen'}</button>
          </div>
        </form>
      </div>
    </div>
  `;
}

export function initBookmarkForm() {
  const form = document.getElementById('bookmark-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    await saveBookmark();
  });

  document.getElementById('close-bookmark-modal')?.addEventListener('click', closeBookmarkForm);
  document.getElementById('cancel-bookmark')?.addEventListener('click', closeBookmarkForm);

  // Close modal on background click
  document.getElementById('bookmark-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'bookmark-modal') {
      closeBookmarkForm();
    }
  });

  // Create tag link
  document.getElementById('create-tag-link')?.addEventListener('click', (e) => {
    e.preventDefault();
    const event = new CustomEvent('show-tag-form');
    document.dispatchEvent(event);
  });
}

async function saveBookmark() {
  const form = document.getElementById('bookmark-form');
  const formData = new FormData(form);

  const data = {
    url: formData.get('url'),
    title: formData.get('title') || undefined,
    description: formData.get('description') || undefined,
    category_id: formData.get('category_id') ? parseInt(formData.get('category_id')) : null,
    tag_ids: Array.from(form.querySelectorAll('input[name="tags"]:checked')).map(cb => parseInt(cb.value)),
  };

  try {
    if (currentBookmark) {
      await api.updateBookmark(currentBookmark.id, data);
      showSuccess('Lesezeichen aktualisiert');
    } else {
      await api.createBookmark(data);
      showSuccess('Lesezeichen erstellt');
    }

    closeBookmarkForm();
    await loadBookmarks();
  } catch (error) {
    console.error('Failed to save bookmark:', error);
    showError('Fehler beim Speichern: ' + error.message);
  }
}

function closeBookmarkForm() {
  const modal = document.getElementById('bookmark-modal');
  if (modal) {
    modal.remove();
  }
  currentBookmark = null;
}

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function showError(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'error', message }
  });
  document.dispatchEvent(event);
}

function showSuccess(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'success', message }
  });
  document.dispatchEvent(event);
}
